import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '~/features/legal/LegalPage';
import { PrivacyContent } from '~/features/legal/PrivacyContent';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

/** Privacy Policy, public. The words live in PrivacyContent, which the build also turns into plain HTML. */
function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy">
      <PrivacyContent />
    </LegalPage>
  );
}
